import React from 'react'

export default function Tab2({name}) {
  return (
    <h4>{name}</h4>
  )
}
